import type { ReactNode } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

interface TooltipProps {
  label: string;
  children: ReactNode;
  enabled?: boolean;
}

export function SidebarTooltip({
  label,
  children,
  enabled = true,
}: TooltipProps) {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={150}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side="right"
            sideOffset={10}
            className="z-50 rounded-md bg-gray-900 px-2.5 py-1 text-[11px] font-medium tracking-[-0.01em] text-white shadow-lg shadow-gray-900/10 pointer-events-none animate-in fade-in-0 slide-in-from-left-1 duration-150"
          >
            {label}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
